import { Injectable, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from './modal.component';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  constructor(private dialog: MatDialog) {}

  open(content: TemplateRef<string>, options?: { size?: string }) {
    this.dialog.open(ModalComponent, {
      width: options?.size,
      data: {
        content,
      },
      disableClose: true,
      autoFocus: true,
    });
  }

  closeModal(): void {
    this.dialog.closeAll();
  }
}
